// extracted by mini-css-extract-plugin
export default {"rating":"WithPremium_rating__cjI7I"};